<div style="padding-left: 15px; padding-right: 15px; text-align: center;" [innerHTML]="componentData.content">
</div>